import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const ExternalReportingNavigationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 24 24'} {...props}>
    <g fill={'currentColor'}>
      <path d={'M2.65 1.75C1.35 3.9.8 6.7.8 9.27s.55 5.37 1.85 7.52l1.43-1.02C3.2 13.92 2.8 11.4 2.8 9.27s.4-4.65 1.28-6.5L2.65 1.75Z'} />
      <path
        d={'M21.35 1.75C22.65 3.9 23.2 6.7 23.2 9.27s-.55 5.37-1.85 7.52l-1.43-1.02c.88-1.85 1.28-4.37 1.28-6.5s-.4-4.65-1.28-6.5l1.43-1.02Z'}
      />
      <path d={'M7.1 4.62C6.3 5.94 6 7.7 6 9.27s.3 3.33 1.1 4.65l1.48-1.06c-.48-1-.7-2.42-.7-3.59s.22-2.59.7-3.59L7.1 4.62Z'} />
      <path d={'M16.9 4.62c.8 1.32 1.1 3.08 1.1 4.65s-.3 3.33-1.1 4.65l-1.48-1.06c.48-1 .7-2.42.7-3.59s-.22-2.59-.7-3.59l1.48-1.06Z'} />
      <circle cx={'12'} cy={'9.27'} r={'1.75'} />
      <path d={'m11.08 10.88-2.52 9.3a1 1 0 1 0 1.93.52L12 15.7l1.51 5a1 1 0 1 0 1.93-.52l-2.52-9.3h-1.84Z'} />
    </g>
  </SvgIcon>
);
